import { api } from "@/api/client";
import { unwrap } from "@/api/errors";

export interface SuggestStartersInput {
  name: string;
  description?: string;
  system_prompt?: string;
}

/** POST /v1/assistants/suggest-starters — generate conversation starters. */
export async function suggestStarters(input: SuggestStartersInput): Promise<string[]> {
  const res = unwrap(
    await api.POST("/v1/assistants/suggest-starters", { body: input }),
  ) as { starters?: string[] };
  return res.starters ?? [];
}
